import HorizontalCreatorSelector from "@/components/HorizontalCreatorSelector";
import Layout from "@/components/Layout";
import SidebarListNavigation from "@/components/SidebarListNavigation";
import * as ScrollArea from "@radix-ui/react-scroll-area";
import clsx from "clsx";
import Link from "next/link";

const CratorLayout = (props) => {
  const {
    creators,
    creator: activeCreator,
    heading,
    headingHref,
    breadcrumbs,
  } = props;

  // Generate an array of nav item objects
  const items = creators.map((creator) => {
    return {
      id: creator.id,
      key: creator.slug,
      label: creator.title,
      href: `/chefs/${creator.slug}`,
      imageSrc: creator.image?.[0]?.url,
      isActive: creator.id === activeCreator?.id,
    };
  });

  const HeadingElement = activeCreator ? "h2" : "h1";

  return (
    <Layout {...props} breadcrumbs={breadcrumbs}>
      <div
        className={clsx(
          "CreatorsLayout",
          "flex min-h-screen flex-col border-t lg:flex-row"
        )}
      >
        {!activeCreator && (
          <div
            className={clsx(
              "CreatorsLayout__mobileHeading",
              "border-b py-4 max-lg:px-6 lg:hidden lg:border-none lg:pb-0"
            )}
          >
            <HeadingElement className="max-w-5xl text-balance text-base">
              <Link href={headingHref}>{heading}</Link>
            </HeadingElement>
          </div>
        )}

        {!!activeCreator && <HorizontalCreatorSelector items={items} />}

        <div
          className={clsx(
            "CreatorsLayout__desktopSidebar",
            "top-header h-screen-minus-header sticky hidden max-w-96 overflow-hidden border-r bg-zinc-100 lg:flex lg:w-3/12 lg:min-w-80 lg:flex-col xl:min-w-96"
          )}
        >
          <ScrollArea.Root
            className={clsx("CreatorsLayout__desktopSidebar", "h-full")}
          >
            <div
              className={clsx("flex h-20 shrink-0 items-center px-6 lg:px-12")}
            >
              <h1 className={clsx("text-base")}>
                <Link href={headingHref}>{heading}</Link>
              </h1>
            </div>
            <ScrollArea.Viewport
              className={clsx("h-full w-full px-6 lg:pl-12 xl:pr-12")}
            >
              <div className={clsx("border-t py-6 pb-30")}>
                <SidebarListNavigation items={items} />
              </div>
            </ScrollArea.Viewport>
            <ScrollArea.Scrollbar
              orientation="vertical"
              className={clsx("")}
            ></ScrollArea.Scrollbar>
          </ScrollArea.Root>
        </div>
        <div className={clsx("CratorLayout__content", "relative w-full")}>
          {props.children}
        </div>
      </div>
    </Layout>
  );
};

export default CratorLayout;
